import { PieChart, Pie, Cell } from "recharts";

export default function App({geoItems, colors}) {

  return (
    <PieChart width={250} height={200}>
      <Pie
        data={geoItems}
        cx={125}
        cy={100}
        innerRadius={60}
        outerRadius={80}
        fill="#8884d8"
        paddingAngle={-5}
        dataKey="value"
      >
        {geoItems.map((item) => (
          <Cell key={`cell-${item.id}`} fill={colors[item.id % colors.length]} />
        ))}
      </Pie>
    </PieChart>
  );
}
